import { Box, Button, Card, Typography } from "@mui/material";
import BackIcon from "components/AppIcons/BackIcon";
import FaiBox from "MuiComponents/FaiBox";
import FaiButton from "MuiComponents/FaiButton";
import FaiTypography from "MuiComponents/FaiTypography";

export default function OrderDetails({ orderData, setOrderDetails }) {
	return (
		<div className="space-y-2">
			<Card className="my-6 p-3 md:p-6 space-y-4">
				<Box className="flex justify-between">
					<Button
						startIcon={<BackIcon />}
						onClick={() => setOrderDetails()}
						className="!p-1 text-theme"
					>
						Back to Orders
					</Button>
					<Box className="flex gap-2" alignItems="center">
						<FaiButton
							color="error"
							// onClick={() => setPaymentDetails()}
							// className="!p-1 text-theme"
						>
							Disable Auto Payment
						</FaiButton>
						<FaiButton
							color="dark"
							// onClick={() => setPaymentDetails()}
							// className="!p-1 text-theme"
						>
							Download Invoice
						</FaiButton>
					</Box>
				</Box>
				<Box>
					<Box
						className="rounded-2xl p-2"
						sx={{ backgroundColor: "#F9E9DA" }}
					>
						<div className="rounded-2xl flex gap-4 justify-between bg-white p-4">
							<div></div>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Merchant Id
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									#561535135
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Merchant Name
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									Merchant Name
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Bank Name
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									State Bank
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Account No.
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									816816816816
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									IFSC Code
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									SBIVD516513
								</Typography>
							</FaiBox>
						</div>
					</Box>
				</Box>
			</Card>
			<Card className="my-6 p-3 md:p-6">
				<FaiBox>
					<FaiTypography
						variant="h4"
						className="!text-xl !font-semibold"
						mb={2}
					>
						Transaction History
					</FaiTypography>
				</FaiBox>
				<Box sx={{ mt: 2 }}>
					{/* <DataList
						data={transactionHistoryData}
						onRowClick={setPaymentDetails}
					/> */}
				</Box>
			</Card>
		</div>
	);
}
